import { InlineFeedback } from '../../feedback/index.js';
import { useFeedback } from '../../feedback/index.js';
import { useEffect, useRef, useState } from 'react';

export function ContentEditorRevisions({ adapter, disabled }) {
  const toast = useFeedback();
  const [revisions, setRevisions] = useState([]);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const generation = useRef(0);
  useEffect(() => {
    const request = ++generation.current;
    setBusy(true); setError(''); setRevisions([]);
    Promise.resolve().then(() => adapter.list()).then((result) => {
      if (generation.current === request) setRevisions(result.revisions || result || []);
    }).catch((failure) => { if (generation.current === request) setError(failure.message); }).finally(() => { if (generation.current === request) setBusy(false); });
    return () => { generation.current += 1; };
  }, [adapter, disabled]);
  const restore = async (revision) => {
    if (disabled) return;
    const request = generation.current;
    setBusy(true); setError('');
    try {
      const result = await adapter.read(revision.id);
      if (generation.current !== request) return;
      const snapshot = result.revision || result;
      await adapter.restore(snapshot.snapshotJson, snapshot);
    } catch (failure) { if (generation.current === request) toast.error(failure.message || 'Revision could not be restored.', { id: 'action:ContentEditorRevisions:restore' }); }
    finally { if (generation.current === request) setBusy(false); }
  };
  return <section aria-label="Document revisions" className="mts-editor-panel"><h2>Revisions</h2>{busy ? <p role="status">Loading revision…</p> : null}
    {revisions.map((revision) => <button type="button" key={revision.id} disabled={disabled || busy} onClick={() => restore(revision)}>Restore revision {revision.revisionNumber} · {revision.status}</button>)}
    {error ? <InlineFeedback variant="error" role="alert">{error}</InlineFeedback> : null}
  </section>;
}
